import UserAvatar from "@mui/material/Avatar";
import { styled } from "@mui/system";

export const StyledAvatar = styled(UserAvatar)(({ theme }) => ({
  backgroundColor: "#ffffff",
  border: "solid 1px #d3d8db",
  "& .defaultAvatar": {
    width: "20px"
  }
}));
